module.exports = __webpack_public_path__ + "static/media/faceRecognition.db1813ad.png";